(ns iris.data.config
  "Feature flag configuration for gradual data source migration.
   
   Each feature can be set to :firebase or :websocket.
   Features will migrate incrementally from Firebase to WebSocket/Redis.")

;; Feature flag configuration
;; :firebase - use Firebase Realtime Database
;; :websocket - use WebSocket/Redis backend
(def feature-flags
  {:raids :firebase              ; raid2eid, eid2raid, raid-cache-id
   :votes :firebase              ; post-votes
   :replies :firebase            ; replies count/timestamp
   :shares :firebase             ; share counts
   :thread-alerts :firebase      ; thread follow/alerts
   :moderation-logs :firebase    ; admin moderation logs
   :user-defaults :firebase      ; default workspace selection
   :user-actions :firebase})     ; last action tracking

(defn get-data-source
  "Returns the configured data source for a given feature.
   Returns :firebase or :websocket"
  [feature]
  (get feature-flags feature :firebase))

(defn using-firebase?
  "Check if a feature is using Firebase"
  [feature]
  (= :firebase (get-data-source feature)))

(defn using-websocket?
  "Check if a feature is using WebSocket"
  [feature]
  (= :websocket (get-data-source feature)))
